/**
 * モバイル用サイドバーメニューをハンバーガーメニューに追加
 */

(function() {
  'use strict';

  function addSidebarMenuToMobile() {
    const container = document.getElementById('mobile-sidebar-menu-container');
    if (!container) return;

    // 既に追加済みの場合は何もしない
    if (container.querySelector('.mobile-sidebar-menu')) return;

    // サイドバーメニューセクションを検索
    const sidebarMenu = document.querySelector('.sidebar-menu');
    if (!sidebarMenu) return;

    // サイドバーメニューの設定を取得
    const heading = sidebarMenu.querySelector('.sidebar-menu__heading');
    const menuList = sidebarMenu.querySelector('.sidebar-menu__list');
    
    if (!menuList) return;

    // モバイル用サイドバーメニューを作成
    const mobileMenu = document.createElement('div');
    mobileMenu.className = 'mobile-sidebar-menu';

    // 見出しを追加
    if (heading) {
      const mobileHeading = document.createElement('h3');
      mobileHeading.className = 'mobile-sidebar-menu__heading';
      mobileHeading.textContent = heading.textContent;
      mobileMenu.appendChild(mobileHeading);
    }

    // ナビゲーションを追加
    const nav = document.createElement('nav');
    nav.className = 'mobile-sidebar-menu__nav';

    const ul = document.createElement('ul');
    ul.className = 'mobile-sidebar-menu__list';

    // メニュー項目をコピー
    const menuItems = menuList.querySelectorAll('.sidebar-menu__item');
    menuItems.forEach(function(item) {
      const link = item.querySelector('.sidebar-menu__link');
      if (!link) return;

      const li = document.createElement('li');
      li.className = 'mobile-sidebar-menu__item';
      if (item.classList.contains('sidebar-menu__item--active')) {
        li.classList.add('mobile-sidebar-menu__item--active');
      }

      const a = document.createElement('a');
      a.className = 'mobile-sidebar-menu__link';
      a.href = link.getAttribute('href');

      const text = document.createElement('span');
      text.className = 'mobile-sidebar-menu__text';
      text.textContent = link.querySelector('.sidebar-menu__text').textContent;

      const arrow = document.createElement('span');
      arrow.className = 'mobile-sidebar-menu__arrow';
      arrow.textContent = '›';

      a.appendChild(text);
      a.appendChild(arrow);
      li.appendChild(a);
      ul.appendChild(li);
    });

    nav.appendChild(ul);
    mobileMenu.appendChild(nav);
    container.appendChild(mobileMenu);
  }

  // DOMContentLoaded後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addSidebarMenuToMobile);
  } else {
    addSidebarMenuToMobile();
  }

  // ハンバーガーメニューが開かれた時にも実行
  document.addEventListener('click', function(e) {
    if (e.target.closest('.header__icon--menu') || e.target.closest('.menu-drawer-container')) {
      setTimeout(addSidebarMenuToMobile, 100);
    }
  });

  // MutationObserverでDOMの変更を監視
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function() {
      addSidebarMenuToMobile();
    });
    
    const container = document.getElementById('mobile-sidebar-menu-container');
    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    }
  }
})();
